import React from 'react';
import { Navigate } from 'react-router-dom';

import { COGNITO_OAUTH_URL } from 'env';

import { useAuthContext } from './Auth';

export const Oauth = () => {
    const { isAuthenticated } = useAuthContext();

    if (isAuthenticated) {
        return <Navigate to="/home" replace />;
    }

    window.location.replace(COGNITO_OAUTH_URL);
    return null;
};
